// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1w3oY","requiredAsterisk":"Info_requiredAsterisk__1eg4-"};